<template>
    <div class="create-edit-group">
        <Loader :loading="showLoader" />

        <!-- Top Toolbar -->
        <v-toolbar class="custom-toolbar mb-4" flat dense>
            <v-btn icon @click="goBack">
                <v-icon size="40">mdi-arrow-left-bold-circle</v-icon>
            </v-btn>
            <v-toolbar-title class="custom-toolbar-title"> {{ $t('groups.create-group') }}</v-toolbar-title>
            <v-spacer />
            <v-btn class="pulse-animation mr-2" variant="tonal" @click="goBack" color="red">
                {{ $t('users.abort') }}
            </v-btn>
            <v-btn size="small" class="pulse-animation" variant="tonal" color="green">
                {{ $t('groups.save') }}
            </v-btn>
        </v-toolbar>

        <!-- Group Info Section -->
        <div class="user-section">
            <h2> {{ $t('groups.information') }}</h2>
            <v-row>
                <v-col cols="12">
                    <v-text-field :label="$t('groups.group-name')" v-model="group.name" variant="outlined" />
                </v-col>
                <v-col cols="12">
                    <v-textarea :label="$t('groups.description')" v-model="group.description" variant="outlined"
                        rows="3" />
                </v-col>
            </v-row>
        </div>

        <!-- Group Members Section -->
        <div class="roles-groups-section">
            <h2> {{ $t('groups.members') }}</h2>
            <v-card-text class="tile-description">{{ $t('groups.add-users-description') }}</v-card-text>
            <v-btn color="primary" class="mb-2">{{ $t('groups.add-users-message') }}</v-btn>
            <v-simple-table dense>
                <!-- <thead>
                    <tr>
                        <th>Name</th>
                        <th>E-Mail</th>
                        <th>Firma</th>
                        <th>Optionen</th>
                    </tr>
                </thead> -->
                <tbody>
                    <!-- <tr>
                        <td colspan="4" class="text-center text--disabled">Keine Objekte anzuzeigen</td>
                    </tr> -->
                </tbody>
            </v-simple-table>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import Loader from '@/components/general/Loader.vue'

const showLoader = ref(false)
const group = ref({
    name: '',
    fakturiaId: '',
    description: '',
})

const goBack = () => window.history.back()
</script>

<style scoped>
.create-edit-group {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.custom-toolbar {
    background-color: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    color: #333;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
}

.custom-toolbar-title {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 1.5rem;
    color: #333;
    margin-left: 10px;
}

.user-section,
.roles-groups-section {
    padding: 1rem;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: #fff;
}

h2 {
    margin-bottom: 1rem;
    font-size: 1.25rem;
    color: #333;
}

.tile-description {
    margin-bottom: 1.5rem;
    font-size: 0.9rem;
    color: #666;
}

@media screen and (max-width: 768px) {
    h2 {
        font-size: 1.15rem;
    }

    .create-edit-group {
        padding: 0.5rem;
    }
}
</style>
